import { render, staticRenderFns } from "./edit-text.vue?vue&type=template&id=13d21428&scoped=true&"
import script from "./edit-text.vue?vue&type=script&lang=js&"
export * from "./edit-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d21428",
  null
  
)

export default component.exports